import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer"

export default function Model() {

    // Click and scroll
    function handleClick(elementId) {
        const scrollElement = document.getElementById(elementId)
        scrollElement.scrollIntoView({behavior: "smooth"});
        // setTimeout(function () {
        //     scrollElement.scrollIntoView({behavior: "smooth"});
        // }, 100);
        console.log(elementId)
    }

    return (
        <div className="flex flex-col h-lvh">

            {/* Header */}
            <Navbar/>

            {/* Sidebar turns into subheader in mobile device */}
            <div className="inset-x-0 bg-white border-b px-4 sm:px-6 md:px-8 lg:hidden">
                <div className="flex items-center py-4">
                    <button type="button" className="text-gray-500 hover:text-gray-600"
                            data-hs-overlay="#description-sidebar" aria-controls="description-sidebar"
                            aria-label="Toggle navigation">
                        <span className="sr-only">Toggle Navigation</span>
                        <svg className="size-5" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </button>
                    <ol className="ms-3 flex items-center whitespace-nowrap">
                        <li className="flex items-center text-sm text-gray-800">
                            Project
                            <svg
                                className="flex-shrink-0 mx-3 overflow-visible size-2.5 text-gray-400"
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </li>
                        <li className="text-sm font-semibold text-gray-800 truncate">
                            Model
                        </li>
                    </ol>
                </div>
            </div>

            {/* Main Content */}
            <div className="lg:flex grow max-w-[85rem] w-full mx-auto">

                {/* Sidebar with accordion */}
                <div id="description-sidebar"
                     className="max-h-svh hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 start-0 bottom-0 z-20 w-72 sm:w-[36rem] bg-white border-e border-gray-200 pt-7 overflow-y-auto lg:static lg:block lg:translate-x-0 lg:end-auto lg:bottom-0 ">
                    <div className="px-6">
                        <div className="flex-none text-xl font-semibold px-1">
                            Model
                        </div>
                    </div>

                    <nav className="p-6 w-full flex flex-col flex-wrap">
                        <ul className="space-y-1.5">
                            <li>
                                <div onClick={() => handleClick("Model-1")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Introduction
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Model-2")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Flux Balance Analysis (FBA)
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Model-3")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Parsimonious flux balance analysis (pFBA)
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Model-4")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Flux Variability Analysis (FVA)
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Model-5")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Modeling Setup and Results
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Model-6")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Future steps
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Model-7")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    References
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>

                {/* Major text sections */}
                <div className="max-h-svh overflow-y-auto w-full px-4 sm:px-6 md:px-24 lg:px-32">
                    <div>
                        <div id="Model-1" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Introduction
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                While we managed to increase guanine expression in the lab, we wondered whether
                                we could expand the scale of production in industry since guanine is a valuable
                                compound in various industries, including pharmaceuticals, cosmetics, and
                                biotechnology. Thus, we performed metabolic engineering to see how to increase
                                guanine yield so that we could enhance its commercial production, making the
                                process more cost-effective and scalable. To achieve this, we used the method
                                named Flux Balance Analysis which is a computational approach that models
                                metabolic networks by simulating the flow of metabolites through the system.
                                It allows us to optimize for specific objectives, such as maximizing guanine
                                yield, by identifying the most efficient distribution of metabolic fluxes.
                                This method helps us predict genetic modifications, like gene knockouts or
                                overexpression, that could further enhance guanine production at an industrial
                                scale.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Model-2" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Flux Balance Analysis (FBA)
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                Flux balance analysis is a widely used methodology for the study of biochemical
                                networks, and it calculates the flow of metabolites through this metabolic network.
                                Unlike traditional simulation methods that rely on accurate kinetic data, FBA is
                                developed based on the principle of conservation of mass in networks where the
                                rate of production and consumption of metabolites is balanced, and it uses random
                                matrices and biologically relevant objective functions to determine the optimal
                                reaction flux distributions. It applies linear programming to optimize an objective
                                function, such as maximizing guanine production, under steady-state conditions. In
                                recent years, FBA has been widely used to analyze genome-scale reconstructions of
                                several organisms, and to analyze the effects of perturbations, such as gene
                                deletion or drug inhibition. To perform FBA, we first construct a metabolic network
                                and define upper and lower bounds for each reaction. Using tools like COBRApy which
                                is a classic constraint-based modeling package, we then execute the FBA to determine
                                the optimal flux distribution that maximizes guanine yield.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/model/model-1.png"
                                className="w-full mt-5"
                                alt=""
                            />
                            <div className="text-center mt-5">
                                Figure 1. The conceptual basis of constraint-based model FBA. (Orth, J, D.; et al. 2010)
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Model-3" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Parsimonious flux balance analysis (pFBA)
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                Parsimonious Flux Balance Analysis is an extension of the traditional FBA method used
                                in metabolic modeling. While FBA focuses on optimizing a specific objective, it
                                often leads to multiple possible solutions, including those that involve excessive,
                                unnecessary fluxes through some reactions. pFBA addresses this by assuming that
                                cells aim to minimize the total flux through the metabolic network to reduce energy
                                or enzyme costs. It does this by first solving a standard FBA to find the optimal
                                objective value and then minimizes the sum of fluxes while still achieving this
                                optimal solution. This allows pFBA to predict more biologically realistic flux
                                distributions by selecting the most efficient set of reactions for achieving the
                                objective. Here, we used pFBA to optimize the FBA model we created.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Model-4" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Flux Variability Analysis (FVA)
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                Flux Variability Analysis is a computational method used in metabolic network
                                modeling to explore the flexibility of flux distributions across reactions.
                                Unlike traditional FBA, which provides a single optimal solution, FVA calculates
                                the minimum and maximum flux values for each reaction that still allow the system
                                to reach the same objective. FVA helps identify non-core reactions that can vary
                                significantly in their flux without affecting the network’s performance, as well
                                as core reactions that are tightly constrained and must carry a specific flux.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Model-5" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Modeling Setup and Results
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                To build the model, we selected iEC1356_Bl21DE3 model from BiGG Model Database for
                                we used E.coli BL21 strain in experiment. After downloading the model, we imported
                                the model through COBRApy package. Setting the model objective to 'EX_gua_e', we
                                aimed at maximize the production of guanine through maximizing the reaction Guanine
                                transport via diffusion (extracellular to periplasm).
                            </div>
                            <div className="text-center mt-5 italic">
                                Reaction: gua_e ⇌ gua_p
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/model/model-2.png"
                                className="w-full mt-5"
                                alt=""
                            />
                            <div className="text-center mt-5">
                                Figure 2. Guanine metabolism pathway (generated by Escher)
                            </div>
                            <div className="mt-5">
                                Once the FBA and pFBA simulation had run, the model revealed that the maximum flux
                                that the guanine pathway could achieve was around 11.365. The model takes glucose,
                                NH4+ and oxygen as input and secreted guanine which will be found in the
                                extracellular medium.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/model/model-3.png"
                                className="w-full mt-5 max-w-xs mx-auto"
                                alt=""
                            />
                            <div className="text-center mt-5">
                                Figure 3. pFBA result to maximize guanine synthesis
                            </div>
                            <div className="mt-5">
                                We performed FVA in the next step which shows the minimum flux and maximum flux for
                                each reaction. It helps to determine the range within which each reaction can vary
                                without affecting the objective function (maximizing guanine production). This
                                provides insights to important reactions affecting guanine synthesis. We could
                                consider knocking out reactions with small or zero flux ranges since they do not
                                significantly contribute to guanine production. For reactions with large variability
                                in flux, we could focus on overexpression to potentially increase guanine yield.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/model/model-4.png"
                                className="w-full mt-5 max-w-xs mx-auto"
                                alt=""
                            />
                            <div className="text-center mt-5">
                                Figure 4. FVA result shows flux range of all reactions
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Model-6" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Future steps
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                To optimize guanine production, the next steps include using FVA results to
                                identify key reactions for gene manipulation, followed by employing Cameo’s
                                OptGene algorithm to predict gene knockouts that redirect flux toward guanine
                                synthesis. Additionally, Cameo’s Flux Scanning (FSEOF) can be used to identify
                                overexpression targets that increase guanine production. After experimental
                                validation through genetic modifications in E. coli BL21, iterative optimization
                                involving further model refinement and experimentation can be performed to
                                continuously improve guanine yield.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Model-7" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            References
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <ol className="list-decimal space-y-4 pl-5">
                                <li>
                                    Orth, J., Thiele, I. & Palsson, B. What is flux balance analysis?. Nat Biotechnol 28, 245–248 (2010). https://doi.org/10.1038/nbt.1614
                                </li>
                                <li>
                                    https://opencobra.github.io/cobrapy/
                                </li>
                                <li>
                                    https://www.creative-proteomics.com/metabolic-flux/flux-balance-analysis-fba.html
                                </li>
                            </ol>
                        </div>
                    </div>

                    <div className="h-16"></div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}